interface UserAvatarProps {
  className?: string
  imageUrl?: string
}

const UserAvatar = ({ className = '', imageUrl }: UserAvatarProps) => {
  // Add default fallback image
  const defaultImage = 'https://github.com/shadcn.png'

  // Process the Google image URL to get a valid URL
  const processImageUrl = (url: string | undefined) => {
    if (!url) return defaultImage

    // Replace the encoded characters and get higher resolution
    return url
      .replace(/=s96-c/, '=s200-c') // Increase image size
      .replace(/\u003d/g, '=') // Fix Google's encoding
  }

  return (
    <img
      src={processImageUrl(imageUrl)}
      alt="Avatar"
      className={`aspect-square size-[42px] min-h-[42px] min-w-[42px] rounded-full border-2 border-white/10 object-cover p-[2px] ${className}`}
      onError={(e) => {
        // Fallback to default image if loading fails
        ;(e.target as HTMLImageElement).src = defaultImage
      }}
    />
  )
}

export default UserAvatar
